import React, {useEffect} from "react";
import {Button, Form, Input, DatePicker, Select} from "antd";
import {useModel} from "../../../models";

const {RangePicker} = DatePicker;

const rangeConfig = {
    rules: [{type: 'array', required: true, message: '请选择制单日期!'}],
};

export default function () {
    const [{saleOrderStatusDict, invoiceTypeDict}, {getSaleOrderStatusDict, getInvoiceTypeDict}] = useModel("cmDict");
    useEffect(() => {
        getSaleOrderStatusDict();
        getInvoiceTypeDict();
    })
    const [{searchParam}, {setSearchParam, loadDocumentList}] = useModel("purchaseOrder");

    const [form] = Form.useForm();
    useEffect(() => {
        form.setFieldsValue(searchParam);
    }, []);

    const onFinish = () => {
        loadDocumentList({showMsg: true, data: searchParam});
    }
    return (
        <Form
            form={form}
            name="material_search"
            layout="inline"
            onFinish={onFinish}
            onValuesChange={e => setSearchParam(e)}
        >
            <Form.Item
                name="saleOrderCode"
                label="销售订单号"
            >
                <Input placeholder="销售订单号"/>
            </Form.Item>

            <Form.Item
                name="customerId"
                label="客户名称"
            >
                <Input placeholder="客户名称"/>
            </Form.Item>
            <Form.Item
                name="orderStatus"
                label="状态"
            >
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="选择状态"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={saleOrderStatusDict}
                />
            </Form.Item>
            <Form.Item
                name="invoiceType"
                label="发票类型"
            >
                <Select
                    showSearch
                    allowClear={true}
                    placeholder="选择发票类型"
                    filterOption={(input, option) => option.label.indexOf(input) >= 0}
                    options={invoiceTypeDict}
                />
            </Form.Item>

            <Form.Item name="startEndDate" label="制单日期" {...rangeConfig}>
                <RangePicker/>
            </Form.Item>
            <Form.Item shouldUpdate={true}>
                {() => (
                    <>
                        <Button
                            type="primary"
                            htmlType="submit"
                        >
                            查询
                        </Button>
                        <Button
                            htmlType="submit"
                            className="margin-left-8"
                        >
                            重置
                        </Button>
                    </>
                )}
            </Form.Item>
        </Form>
    );
}